jQuery(function ($)
{
	var x = $('.DiningGallery');

    var GalleryInit = function (GalleryID, GalleryThumbnailID)
    {
        var $GalleryPartial = $('#Gallery_' + GalleryID);
        var $GalleryNavPartial = $('#Gallery_' + GalleryThumbnailID);

        $GalleryPartial.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            fade: true,
            asNavFor: '#Gallery_' + GalleryThumbnailID
        });
        $GalleryNavPartial.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '#Gallery_' + GalleryID,
            dots: false,
            centerMode: true,
            centerPadding: "50px",
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }

            ]
        });

        if ($GalleryNavPartial.slick("getSlick").slideCount < 6) {
            $GalleryNavPartial.slick("slickSetOption", "centerMode", false);
        }

    };


    $('.DiningGallery').each(function ()
    {
        var gID = $('.PrimaryGallery', this).attr('data-gallery-id');
        var gThumbID = $('.ThumbnailGallery', this).attr('data-gallery-thumbnail-id');
        GalleryInit(gID, gThumbID);
    })


});